import { getFullName } from "utils/getFullName";

export const compareByAssignedAt = (a, b) =>
  new Date(a.assignedAt ?? 0) - new Date(b.assignedAt ?? 0);

const sanitize = (str = "") => str.toLowerCase().trim();

export const matchesSearch = (user, term) => {
  if (!term) {
    return true;
  }

  const s = sanitize(term);
  const displayName = getFullName(user);

  return (
    sanitize(displayName).includes(s) || sanitize(user.userName).includes(s)
  );
};
